import React from 'react';
export var NotVisible = function NotVisible() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "21",
    height: "16",
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8.54305C0 8.54305 4.52467 14.3372 10.1061 14.3372C15.6876 14.3372 20.2123 8.54305 20.2123 8.54305C20.2123 8.54305 15.6876 2.74886 10.1061 2.74886C4.52467 2.74886 0 8.54305 0 8.54305ZM1.4976 8.54305C1.53614 8.58479 1.57639 8.62798 1.61832 8.67251C2.10186 9.18613 2.80142 9.8706 3.6628 10.5529C5.41459 11.9404 7.69239 13.2053 10.1061 13.2053C12.5199 13.2053 14.7977 11.9404 16.5495 10.5529C17.4109 9.8706 18.1104 9.18613 18.594 8.67251C18.6359 8.62798 18.6761 8.58479 18.7147 8.54305C18.6761 8.50131 18.6359 8.45811 18.594 8.41358C18.1104 7.89996 17.4109 7.21549 16.5495 6.53324C14.7977 5.14573 12.5199 3.88075 10.1061 3.88075C7.69239 3.88075 5.41459 5.14573 3.6628 6.53324C2.80142 7.21549 2.10186 7.89996 1.61832 8.41358C1.57639 8.45811 1.53614 8.50131 1.4976 8.54305Z",
    fill: "inherit",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1331 10.3487C11.9192 10.3487 13.3671 8.90078 13.3671 7.11471C13.3671 5.32864 11.9192 3.88075 10.1331 3.88075C8.34703 3.88075 6.89913 5.32864 6.89913 7.11471C6.89913 8.90078 8.34703 10.3487 10.1331 10.3487ZM10.1331 11.4806C12.5443 11.4806 14.4989 9.52591 14.4989 7.11471C14.4989 4.70352 12.5443 2.74886 10.1331 2.74886C7.7219 2.74886 5.76724 4.70352 5.76724 7.11471C5.76724 9.52591 7.7219 11.4806 10.1331 11.4806Z",
    fill: "inherit",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7856 0.400183C17.0066 0.621198 17.0066 0.979533 16.7856 1.20055L2.38634 15.5998C2.16532 15.8208 1.80699 15.8208 1.58597 15.5998C1.36496 15.3788 1.36496 15.0205 1.58597 14.7995L15.9852 0.400183C16.2063 0.179168 16.5646 0.179168 16.7856 0.400183Z",
    fill: "inherit",
    stroke: "none"
  }));
};